import React from 'react';

import GridArrow from '../components/BuilderGridCarousel/GridArrow';

// Breakpoints are based on design requirements -
// the slide configuration looked better with these.
export const carouselBreakpoints = {
  large: 1024,
  medium: 744,
  small: 600,
};

export const carouselSlideOptions = {
  small: 2,
  medium: 3,
  large: 4,
  xlarge: 6,
};

export const options = (showArrowsOnMobile = false) => {
  return {
    arrows: true,
    nextArrow: <GridArrow />,
    prevArrow: <GridArrow scrollDirection="previous" />,
    dots: false,
    slidesToShow: carouselSlideOptions.xlarge,
    slidesToScroll: carouselSlideOptions.xlarge,
    responsive: [
      {
        breakpoint: carouselBreakpoints.large,
        settings: {
          slidesToShow: carouselSlideOptions.large,
          slidesToScroll: carouselSlideOptions.large,
        },
      },
      {
        breakpoint: carouselBreakpoints.medium,
        settings: {
          slidesToShow: carouselSlideOptions.medium,
          slidesToScroll: carouselSlideOptions.medium,
        },
      },
      {
        breakpoint: carouselBreakpoints.small,
        settings: {
          arrows: showArrowsOnMobile,
          slidesToShow: carouselSlideOptions.small,
          slidesToScroll: carouselSlideOptions.small,
        },
      },
    ],
  };
};
